<template>
  <!-- temporary
  :value="drawer"
  stateless
   -->
  <v-navigation-drawer
    :mini-variant.sync="drawer"
    mini-variant-width="70"
    permanent
    app
    id="mainnav"
    class="secondary"
  >
    <v-list class="white--text pb-5">
      <v-list-item class="">
        <v-list-item-avatar size="50">
          <v-img width="10" src="/img/Dimitra_logo_white.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-title class="text-h5 font-weight-bold white--text"
          >DIMITRA</v-list-item-title
        >
      </v-list-item>
    </v-list>
    <!-- BUTTON FOR CLOSING DRAWER -->
    <!-- <v-btn
      @click.stop="setDrawer()"
      style="position: absolute; top: 10px; right: 10px; z-index: 10"
      fab
      dark
      small
      color="primary"
    >
      <v-icon dark> mdi-close </v-icon>
    </v-btn> -->
    <!-- BUTTON FOR CLOSING DRAWER -->
    <v-divider color="gray"></v-divider>
    <v-list nav dense v-for="(item, idx) in permissions" :key="idx">
      <v-list-item
        :exact="item.exact"
        active-class="primary"
        class=""
        v-if="!item.submenus"
        :to="item.url"
        link
      >
        <v-list-item-icon>
          <v-icon v-if="item.icon" class="white--text font-weight-bold">{{
            item.icon
          }}</v-icon>
          <img v-else :src="item.src" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text font-weight-bold">{{
            item.name
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group
        v-else
        :value="false"
        no-action
        active-class="primary"
        class="white--text has-subgroups"
      >
        <template #prependIcon>
          <v-icon class="white--text">{{ item.icon }}</v-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title class="white--text font-weight-bold">{{
              item.name
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="(subitem, i) in item.submenus"
          :key="i"
          :to="subitem.url"
          link
          exact-active-class="primary"
        >
          <v-list-item-icon v-if="subitem.icon">
            <v-icon class="white--text">{{ subitem.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title
            v-text="subitem.name"
            class="white--text"
          ></v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
    <template v-slot:append>
      <div class="text-no-wrap text-caption text-center white--text mb-5">
        Version <br v-if="drawer" />
        1.0.0
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import isMobileMixin from "@/mixins/isMobileMixin";
export default {
  name: "sidebar",
  created() {},
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        return this.$store.commit("SET_DRAWER", !val);
      },
    },
    permissions() {
      return this.$store.getters.getUserPermissions(this.menuItems);
    },
  },
  methods: {
    setDrawer() {
      this.$store.commit("SET_DRAWER", !this.$store.state.drawer);
    },
  },
  watch: {
    "$store.state.drawer": function(value) {
      console.log(value, "value");
    },
  },
  data() {
    return {
      menuItems: [
        {
          id: 10,
          icon: "mdi-view-grid-outline",
          name: this.$t("dashboard"),
          url: { name: "AdminDashboard" },
          exact: true,
        },
        {
          id: 2,
          src: "/img/users_sidebar_icon.svg",
          name: this.$t("users"),
          url: { name: "Users" },
          exact: false,
        },
        {
          id: 5,
          icon: "mdi-tab-unselected",
          name: this.$t("farms"),
          url: { name: "My farm" },
          exact: false,
        },
        {
          id: 1,
          icon: "mdi-cow",
          name: this.$t("animals"),
          url: { name: "Animals" },
          exact: false,
        },
        {
          id: 11,
          icon: "mdi-dots-horizontal-circle-outline",
          name: this.$t("actionList"),
          url: { name: "ActionList" },
          exact: false,
        },
        {
          id: 12,
          icon: "mdi-pill",
          name: this.$t("drugInventory"),
          url: { name: "DrugList" },
          exact: false,
        },
        {
          id: 13,
          icon: "mdi-file-chart",
          name: this.$t("reporting"),
          url: { name: "Analytics" },
          exact: false,
          submenus: [
            // {
            //   icon: "mdi-file-chart",
            //   name: this.$t("reports.dataScientistReport"),
            //   url: { name: "AnalyticsDatasci" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name: this.$t("reports.breederReport"),
            //   url: { name: "AnalyticsBreeder" },
            // },
            {
              icon: "mdi-file-chart",
              name: this.$t("reportings.healthReport"),
              url: { name: "AnalyticsHealth" },
            },
            // {
            //   icon: "mdi-file-chart",
            //   name: this.$t("reports.productReport"),
            //   url: { name: "AnalyticsProduct" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name: this.$t("reports.semenEmbryoReport"),
            //   url: { name: "AnalyticsSemenEmb" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name: this.$t("reports.productionReport"),
            //   url: { name: "AnalyticsProduction" },
            // },
          ],
        },
        // {
        //   id: 13,
        //   icon: "mdi-file-chart",
        //   name: this.$t("analytics"),
        //   url: { name: "Analytics" },
        //   exact: false,
        //   submenus: [
        //     {
        //       icon: "mdi-file-chart",
        //       name: this.$t("sidebar.productionAnalytics"),
        //       url: { name: "calfAnalytics" },
        //     },
        //     {
        //       icon: "mdi-file-chart",
        //       name: this.$t("sidebar.healthAnalytics"),
        //       url: { name: "pregnancyAnalytics" },
        //     },
            // {
            //   icon: "mdi-file-chart",
            //   name: "Health Report",
            //   url: { name: "AnalyticsHealth" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name: "Product Report",
            //   url: { name: "AnalyticsProduct" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name: "Semen/Embryo Report",
            //   url: { name: "AnalyticsSemenEmb" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name: "Production Report",
            //   url: { name: "AnalyticsProduction" },
            // },
        //   ],
        // },
        {
          id: 16,
          icon: "mdi-chart-areaspline",
          name: this.$t("inseminatorStatistics"),
          url: { name: "InseminatorList" },
          exact: false,
        },
        // {
        //   id: 14,
        //   src: "/img/org_ntr_icon.svg",
        //   name: this.$t("organizationNTR"),
        //   url: { name: "ProductList" },
        //   exact: false,
        // },
        // {
        //   id: 5,
        //   src: "/img/ggg.png",
        //   name:  this.$t("geneticsAndBreeding.geneticsAndBreeding"),
        //   url: { name: "Genetics" },
        //   exact: false,
        // },
        {
          id: 21,
          icon: "mdi-file-chart",
          name: this.$t("geneticsAndBreeding.geneticsAndBreeding"),
          exact: false,
          submenus: [
             {
               icon: "mdi-file-chart",
               name:  this.$t("geneticsAndBreeding.animalSelection"),
               url: { name: "GeneticsListV2" },
               exact: false,
            },
            {
              icon: "mdi-file-chart",
              name: this.$t('geneticsAndBreeding.geneticSearchTool'),
              url: { name: "GeneticSearch" },
              exact: false
            },
            {
              icon: "mdi-file-chart",
              name: this.$t('geneticsAndBreeding.manageAnimalsGrouping'),
              url: { name: "ManageAnimalsGroup" },
            },
            {
              icon: "mdi-file-chart",
              name: this.$t('geneticsAndBreeding.contemporaryGroupsSettings'),
              url: { name: "contemporaryGroups" },
            },
            {
              icon: "mdi-cog",
              name: this.$t('geneticsAndBreeding.epdModelSettings'),
              url: { name: "modelSettings" },
            },
            {
              icon: "mdi-cog",
              name: this.$t('geneticsAndBreeding.epdRequiredFieldSettings'),
              url: { name: "requiredFieldsSetting" },
            },
            // {
              // icon: "mdi-file-chart",
              // name: "CG Reports",
              // url: { name: "cgReports" }
            // },
            {
              icon: "mdi-file-chart",
              name: this.$t('userGuide'),
              url: { name: "UserGuide" }
            },
            // {
              // icon: "mdi-file-chart",
              // name: "Manage Bulk Uploads",
              // url: { name: "bulkUploadStatus" }
            // }
          ],
        },
        // { id: 18 , icon: "mdi-bank-outline", name: "Semen Gene Bank", url: { name: 'GeneList'} , exact: false},
        {
          id: 17,
          icon: "mdi-file-chart",
          name: this.$t("genotypePerformance"),
          url: { name: "GenoList" },
          exact: false,
        },
        {
          id: 15,
          icon: "mdi-chart-areaspline",
          name: this.$t("semenAutomation"),
          url: { name: "SemenAuto" },
          exact: false,
        },
        {
          id: 19,
          icon: "mdi-chart-areaspline",
          name: this.$t("activityLogs"),
          url: { name: "ActivityLog" },
          exact: false,
        },
        // { icon: "account", name: "User Profile", url: { name: 'profile'}, exact: false },
      ],
    };
  },
  mixins: [isMobileMixin],
};
</script>

<style>
.v-application--is-ltr .v-list--dense.v-list--nav .v-list-group--no-action > .v-list-group__items > .v-list-item{
  padding-left: 16px;
}
.has-subgroups .v-list-group__header.v-list-item.v-list-item--active.v-list-item--link.theme--light.primary
{
  background-color: rgba(0,189,115,0.1) !important;
}
</style>
